import { useEffect } from 'react'

const BASE_TITLE = 'Webba iD'

export function usePageTitle(title?: string, suffix?: string) {
  useEffect(() => {
    if (title) {
      document.title = suffix
        ? `${title} - ${suffix}`
        : `${title} - ${BASE_TITLE}`
    } else {
      document.title = BASE_TITLE
    }

    return () => {
      document.title = BASE_TITLE
    }
  }, [title, suffix])
}
